import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { HeaderNavigationLinksContainer, HeaderNavigationLinksRoot } from './style';
import { useComponentTheme } from '../../../utils/hooks';
import { HEADER_NAVIGATION_LINKS_CLASS_PREFIX, headerNavigationLinksRoot } from './constants';
import useHeaderNavigationLinksClassName from './utils/useHeaderNavigationLinksClassName';
import { headerNavigationLinks } from './theme';
import HeaderNavigationLinksContext from './HeaderNavigationLinksContext';
import { useHeaderNavigationLinks } from './utils/useHeaderNavigationLinks';
export var HeaderNavigationLinks = forwardRef(function HeaderNavigationLinks(_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ["className", "children"]);

  var theme = useComponentTheme(HEADER_NAVIGATION_LINKS_CLASS_PREFIX, headerNavigationLinks);
  var classOverride = useHeaderNavigationLinksClassName(HEADER_NAVIGATION_LINKS_CLASS_PREFIX, className);

  var _useHeaderNavigationL = useHeaderNavigationLinks(restProps),
      result = _useHeaderNavigationL.result,
      restRootProps = _useHeaderNavigationL.restProps;

  return React.createElement(HeaderNavigationLinksContext.Provider, {
    value: result.headerNavigationLinksContextValue
  }, React.createElement(HeaderNavigationLinksRoot, Object.assign({
    "data-testid": headerNavigationLinksRoot
  }, restRootProps, {
    theme: theme,
    className: classOverride.Root,
    flexGrow: 1,
    ref: ref
  }), React.createElement(HeaderNavigationLinksContainer, {
    theme: theme,
    className: classOverride.Container
  }, children)));
});
HeaderNavigationLinks.defaultProps = {
  locationTracking: true
};